import {getFormattedPrice} from "../utils/get-formatted-price";
import {createParagraph} from "./create-paragraph";

export const createPriceElement = (className, price) => {
  const formattedPrice = getFormattedPrice(price);

  return createParagraph(`${className} price`, formattedPrice);
};
